// this page created by akash-ak

import Input from '../../../../Core/Fields/Floating/Input';
import MultiFileInput from '../../../../Core/Fields/Floating/MultiFileInput';

const Tab2 = ({ tabTwoFormData, onInputChange, errors }) => {
  return (
    <div className="row" style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: '20px' }}>
      <div className="col-12">
        <p className="boxLabel m-0">Invoice Details</p>
      </div>

      <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              id="invoice_no"
              label="Invoice No."
              value={tabTwoFormData.invoice_no}
              onChange={(e) => onInputChange('invoice_no', e.target.value)}
              className={errors?.invoice_no ? 'error-border' : ''}
              style={{
                height: "30px",
                whiteSpace: 'pre-wrap',
                border: errors?.invoice_no ? '1px solid red' : ''
              }}
            />
          </div>
        </div>

        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <MultiFileInput
              name="Invoice Image"
              style={{ height: "30px" }}
              setFile={(files) => onInputChange("invoice_image", files)}
              error={errors?.invoice_image}
            />
            {/* {errors?.invoice_image && <div className="error-text">Image This field is required</div>} */}

          </div>
        </div>

        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              type="date"
              id="invoice_date"
              label="Invoice Date"
              value={tabTwoFormData.invoice_date}
              onChange={(e) => onInputChange('invoice_date', e.target.value)}
              className={errors?.invoice_date ? 'error-border' : ''}
              style={{
                height: "30px",
                whiteSpace: 'pre-wrap',
                border: errors?.invoice_date ? '1px solid red' : ''
              }}
            />
          </div>
        </div>
      </div>

      <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              id="total_no_boxes"
              label="Total No. Boxes"
              style={{ height: "30px" }}
              value={tabTwoFormData.total_no_boxes}
              onChange={(e) => onInputChange('total_no_boxes', e.target.value)}
              className={errors?.total_no_boxes ? 'error-border' : ''}
              readOnly
            />
          </div>
        </div>

        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              id="invoice_value"
              label="Invoice Value"
              style={{
                height: "30px",
                whiteSpace: 'pre-wrap',
                border: errors?.invoice_value ? '1px solid red' : ''
              }} value={tabTwoFormData.invoice_value}
              onChange={(e) => onInputChange('invoice_value', e.target.value)}
            />
            {/* {errors?.invoice_value && <div className="error-text">This field is required</div>} */}

          </div>
        </div>

        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              id="total_invoice_qty"
              label="Total Invoice Qty"
              style={{
                height: "30px",
                whiteSpace: 'pre-wrap',
                border: errors?.total_invoice_qty ? '1px solid red' : ''
              }}
              value={tabTwoFormData.total_invoice_qty}
              onChange={(e) => onInputChange('total_invoice_qty', e.target.value)}
            />
            {/* {errors?.total_invoice_qty && <div className="error-text">This field is required</div>} */}

          </div>
        </div>
      </div>
      <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
        <div style={{ flex: '1' }}>
          <div className="mb-3">
            <Input
              id="eway_bill"
              label="Eway Bill"
              value={tabTwoFormData.eway_bill}
              onChange={(e) => onInputChange('eway_bill', e.target.value)}
                   style={{
                  height: "30px",
                  width: '32.5%',
                  whiteSpace: 'pre-wrap',
                  border: errors?.eway_bill ? '1px solid red' : ''
                }}
                
            />

          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab2;